<template>
  <div class="recharge-store-box">
    <NvHeader title="Recharge Store" :backFn="handleBack" />
    <div class="store-cards-container">
      <NvRechargeCard type="page" ref="store" :redirect="redirectUrl">
        <div class="header" slot="prepend">
          <div class="title">Products</div>
          <div class="content">
            Top up to unlock novels you want.
          </div>
        </div>
        <div slot="append" class="footer">
          <div class="title">Tips:</div>
          <div class="content">
            1. Coins are available on NovelFun to unlock any novels you want. <br />
            2. If you have any question, please contact us in Messenger.
          </div>
        </div>
      </NvRechargeCard>
    </div>
    <NvConfirm
      title="Purchase Failed"
      content="An error occurred during the purchasing process. If you haven't received your coins, please tap on Restore to continue with your order. "
      confirmText="Restore"
      @confirm="handleRestore"
      @close="showRestoreModal = false"
      :showCancel="false"
      :show="showRestoreModal"
    />
  </div>
</template>

<script>
import NvHeader from "@/components/widget/NvHeader";
import NvRechargeCard from "@/components/widget/my/NvRechargeCard";
import NvConfirm from "@/components/widget/NvConfirm";
import { Toast } from "vant";

// order status
// 0: pending
// 1: success
// 2: fail

export default {
  components: {
    NvHeader,
    NvRechargeCard,
    NvConfirm
  },
  data() {
    return {
      showRestoreModal: false
    };
  },
  computed: {
    redirectUrl() {
      const suffix = "/#/me/recharge-store";
      return `${window.location.origin}${suffix}`;
    }
  },
  methods: {
    handleBack() {
      const fromBook = this.backPage === "content";
      if (fromBook) {
        return this.$router.go(-1);
      } else {
        return this.$router.replace({ name: this.backPage });
      }
    },
    handleRestore() {
      this.showRestoreModal = false;
      window.$event("Restore_Button_Click", {});
      this.$refs.store.buy(false);
    },
    handleOrderStatus(order) {
      if (order.status == 2) {
        this.showRestoreModal = true;
        window.$event("Purchase_Failed_Show", {});
      } else if (order.status == 1) {
        window.$event("Buy_Successfully", {});
        Toast({
          message: "Buy successfully",
          className: "toast-box"
        });
      } else {
        // remove order result query strings
        const newQuery = Object.assign({}, order);
        delete newQuery.orderId;
        delete newQuery.status;
        this.$router.replace({ query: newQuery });
      }
    }
  },
  mounted() {
    window.$event("Recharge_Store_Page_Show", {
      from: this.backPage === "content" ? "view_all" : "mine"
    });
    const query = this.$route.query;
    if (query.orderId || query.status) {
      this.handleOrderStatus(query);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.backPage = from.name === "content" ? "content" : "me";
    });
  }
};
</script>

<style lang="scss" scoped>
.recharge-store-box {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 0 16px;
  .store-cards-container {
    margin-top: 50px;
    height: 100%;
    .header,
    .footer {
      width: 100%;
      padding: 12px 0;
      .title {
        font-weight: 600;
      }
      .content {
        font-size: $fs-xs;
        color: $fc-grey;
        font-weight: 300;
        padding: 5px 0;
        line-height: 1.5;
      }
    }
    .footer {
      padding-bottom: 90px;
    }
  }
}
</style>
